import { constants } from '../utitlity/constant';
import { Helper } from '../utitlity/helper';

export class DipModel {
    template: string;
    customerNumber: string;
    actualAccountNumber: string;
    jadeIndicator: boolean;
    bureauData: any;
    bureauDecline: boolean;
    arn: string;
    private refferedProducts: SMG3Product[];
    private acceptedProducts: SMG3Product[];
    private declinedProducts: SMG3Product[];

    get rfProductList() {
        return this.refferedProducts;
    }

    get acProductList() {
        return this.acceptedProducts;
    }

    get dlProductList() {
        return this.declinedProducts;
    }

    set rfProductList(data) {
        if (data) {
            this.refferedProducts = data.map((product) => {
                return new SMG3Product(product);
            });
        }
    }

    set acProductList(data) {
        if (data) {
            this.acceptedProducts = data.map((product) => {
                return new SMG3Product(product);
            });
        }
    }

    set dlProductList(data) {
        if (data) {
            this.declinedProducts = data.map((product) => {
                return new SMG3Product(product);
            });
        }
    }

    isCustomerHaveAcc(): boolean {
        let data = this.acceptedAccount() || this.refferedAccount();
        return data ? true : false;

    }

    isCustomerHaveCard() {
        let data = this.acceptedCard() || this.refferedCard();
        return data ? true : false;
    }

    isCustomerHaveOD() {
        let data = this.acceptedOD() || this.refferedOD();
        return data ? true : false;
    }

    acceptedAccount() {
        let result;
        if (this.acceptedProducts && this.acceptedProducts.length) {
           result =  this.acceptedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_ACCOUNT;
            })[0];
        }
        return result || new SMG3Product();
    }

    refferedAccount(): SMG3Product {
        let result;
        if (this.refferedProducts && this.refferedProducts.length) {
            result = this.refferedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_ACCOUNT;
            })[0];
        }
        return result || new SMG3Product();
    }

    declinedAccount(): SMG3Product {
        let result;
        if (this.declinedProducts && this.declinedProducts.length) {
            result = this.declinedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_ACCOUNT;
            })[0];
        }
        return result || new SMG3Product();
    }

    acceptedCard(): SMG3Product {
        let result;
        if (this.acceptedProducts && this.acceptedProducts.length) {
            result = this.acceptedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_CARD;
            })[0];
        }
        return result || new SMG3Product();
    }

    refferedCard(): SMG3Product {
        let result;
        if (this.refferedProducts && this.refferedProducts.length) {
            result = this.refferedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_CARD;
            })[0];
        }
        return result || new SMG3Product();
        
    }

    declinedCard(): SMG3Product {
        let result;
        if (this.declinedProducts && this.declinedProducts.length) {
            result = this.declinedProducts.filter((product) => {
                return product.productType == constants.PRODUCT_CARD;
            })[0];
        }
        return result || new SMG3Product()
    }

    acceptedOD(): SMG3Product {
        let result;
        if (this.acceptedProducts && this.acceptedProducts.length) {
            result = this.acceptedProducts.filter((product) => {
                return product.productType == constants.OVERDRAFT_PRODUCT;
            })[0];
        }
        return result || new SMG3Product();
    }

    refferedOD(): SMG3Product {
        let result;
        if (this.refferedProducts && this.refferedProducts.length) {
            result = this.refferedProducts.filter((product) => {
                return product.productType == constants.OVERDRAFT_PRODUCT;
            })[0];
        }
        return result || new SMG3Product();
    }

    declinedOD(): SMG3Product {
        let result;
        if (this.declinedProducts && this.declinedProducts.length) {
            result = this.declinedProducts.filter((product) => {
                return product.productType == constants.OVERDRAFT_PRODUCT;
            })[0];
        }
        return result || new SMG3Product();
    }

    getDipMessage() {
        let message = new DIPMessage(this);
        return message.getMessage();
    }

    constructor(response?) {
        if (response) {
            this.template = response.template;
            this.jadeIndicator = response.jadeIndicator;
            this.actualAccountNumber = response.actualAccountNumber;
            this.customerNumber = response.customerNumber;
            this.bureauData = response.bureauData;
            this.bureauDecline = response.bureauDecline;
            this.rfProductList = response.rfProductList;
            this.acProductList = response.acProductList;
            this.dlProductList = response.dlProductList;
            this.arn = response.arn;
        }
    }

}

export class SMG3Product {
    productCode: string;
    productType: string;
    decision: string;
    maxLimit: any;
    minLimit: any;
    upsell: any;
    downsell: any;
    userdecision: string;
    userLimit: any;
    feeCode: any;
    productDescription: string;
    interestRate: any;
    reasonCodes: any[];
    iQueueCodes: any[];

    constructor(product?) {
        if (product) {
            this.productCode = product.productCode;
            this.productType = product.productType;
            this.decision = product.decision;
            this.maxLimit = product.maxLimit;
            this.minLimit = product.minLimit;
            this.upsell = product.upsell;
            this.downsell = product.downsell;
            this.userdecision = product.userdecision;
            this.userLimit = product.userLimit;
            this.feeCode = product.feeCode;
            this.productDescription = product.productDescription;
            this.reasonCodes = product.reasonCodes;
            this.iQueueCodes = product.iQueueCodes;
            this.interestRate = product.interestRate;
        }
    }
}

class DIPMessage {
    dipData: DipModel;
    getMessage() {
        let message;
        switch (this.dipData.template) {
            case "ACAL":
                message = this.getACALMessage();
                break;
            case "DLAL":
                message = this.getDLALMessage();
                break;
            case "RFAL":
                message = this.getRFALMessage();
                break;
            case "ACDL":
                message = this.getACDLMessage();
                break;
            case "ACRF":
                message = this.getACRFMessage();
                break;
            case "RFDL":
                message = this.getRFDLMessage();
                break;
            default:
                break;
        }

        return message;
    }

    getACALMessage() {
        let acceptedAccount = this.dipData.acceptedAccount();
        let acceptedOD = this.dipData.acceptedOD();
        let acceptedCard = this.dipData.acceptedCard();
        return `<h3 class="displayMessageDiph3"><span class="red-bg-text">Congratulations!</span>
        <br />You have been approved in principle for the <strong>${acceptedAccount ? acceptedAccount.productDescription : ''}</strong>
        <span>${acceptedOD ? ' with <strong>Overdraft</strong>' : ''}</span><span>${(acceptedCard && (acceptedAccount || acceptedOD)) ? ' and ' : ''}</span>
        <strong> ${acceptedCard ? acceptedCard.productDescription : ''}</strong></h3>`;
    }
    getDLALMessage() {
        return `<h3 class="displayMessageDiph3">Thank you for your application with <strong>HSBC</strong></h3>
        <h6 style="color: #a0adb4;">Application reference number:
        <span style="color: #000;">${this.dipData.arn}</span>.
        <br /><br />Unfortunately, based on the information you have provided, we cannot offer you a product at this time.
        <br /><br />Please contact us on <span style="color: #000;">600 55 4722</span> (within the UAE) or
        <span style="color: #000;">+971 4 228 8007</span> (outside the UAE) quoting the above reference number if you need any further information.</h6>`;
    }
    getACDLMessage() {
        let acceptedAccount = this.dipData.acceptedAccount();
        let acceptedCard = this.dipData.acceptedCard();
        let acceptedOD = this.dipData.acceptedOD();
        let declinedAccount = this.dipData.declinedAccount();
        let declinedCard = this.dipData.declinedCard();
        let declinedOD = this.dipData.declinedOD();
        let bureauDecline = this.dipData.bureauDecline;

        return `<h3 class="displayMessageDiph3">
                    <span class="red-bg-text">Congratulations!</span>
                    <br>You have been approved in principle for the
                    <strong>${acceptedAccount.productType ? acceptedAccount.productDescription : ''}</strong>
                    <span>${acceptedOD.productType ? ' with <strong>Overdraft</strong>' : ''}</span>
                    <span> ${(acceptedCard.productType && (acceptedAccount.productType || acceptedOD.productType)) ? ' and ' : ''}</span>
                    <strong>${acceptedCard.productType ? acceptedCard.productDescription : ''}</strong>
                </h3>
                <h6>
                    <span>${!bureauDecline ? 'Unfortunately, based on the information provided we are not able to offer you the' : ''}
                        <span>${!bureauDecline && declinedOD && declinedOD.productType ? '<span style="color: #000;">Overdraft</span>' : ''}</span>
                        <span>${(!bureauDecline && declinedCard.productType && (declinedOD.productType || declinedAccount.productType)) ? ' and ' : ''}</span>
                        <span style="color: #000;">${!bureauDecline ? declinedCard.productDescription : ''}</span>
                    </span>
                </h6>
                <h6>
                    <span>${bureauDecline ? '<br />Unfortunately, we are not able to offer you the' : ''}
                        <span>${bureauDecline && declinedOD && declinedOD.productType ? '<span style="color: #000;">Overdraft</span>' : ''}</span>
                        <span>${declinedCard.productType && (declinedOD.productType || declinedAccount.productType) ? ' and ' : ''}</span>
                        <span style="color: #000;">${bureauDecline ? declinedCard.productDescription : ''}</span>${bureauDecline ? ', based on the information you have provided ()' : ''}
                    </span>
                </h6>`;
    }
    getRFALMessage() {
        let refferedAccount = this.dipData.refferedAccount();
        let refferedCard = this.dipData.refferedCard();
        let refferedOD = this.dipData.refferedOD();

        return `<h3 class="displayMessageDiph3">
        <span class="red-bg-text">Based on the information you have provided</span>
        <br /> You are eligible for the
        <strong>${refferedAccount.productType ? refferedAccount.productDescription : ''} </strong>
        <span>${refferedOD.productType ? 'with <strong>Overdraft</strong>' : ''}</span>
        <span>${(refferedCard.productType && (refferedAccount.productType || refferedOD.productType)) ? 'and' : ''}</span>
        <strong>${refferedCard.productType ? refferedCard.productDescription : ''}</strong>
        </h3>
        <h6>
            <span class="displayMessageDipSpan">However, we will need further information from you before we can provide you with a final approval.</span>
        </h6>`;
    }

    getACRFMessage() {
        let acceptedAccount = this.dipData.acceptedAccount();
        let acceptedCard = this.dipData.acceptedCard();
        let acceptedOD = this.dipData.acceptedOD();
        let refferedAccount = this.dipData.refferedAccount();
        let refferedCard = this.dipData.refferedCard();
        let refferedOD = this.dipData.refferedOD();

        return `<h3 class="displayMessageDiph3">
        <span class="red-bg-text">Congratulations!</span>
        <br />You have been approved in principle for the
        <strong>${acceptedAccount.productType ? acceptedAccount.productDescription : ''}</strong>
        <span>${acceptedOD && acceptedOD.productType ? ' with <strong>Overdraft</strong>':''}</span>
        <span>${acceptedCard.productType && (acceptedOD.productType || acceptedAccount.productType) ? ' and ' : ''}</span>
        <strong>${acceptedCard.productType ? acceptedCard.productDescription: ''}</strong>
        </h3>
        <h6>
            <span class="displayMessageDipSpan">However we need further information from you before we can confirm the status of your application for
                <strong>${refferedCard.productType ? refferedCard.productDescription : ''}</strong>.</span>
        </h6>`;
    }

    getRFDLMessage() {
        let refferedAccount = this.dipData.refferedAccount();
        let refferedCard = this.dipData.refferedCard();
        let refferedOD = this.dipData.refferedOD();
        let declinedAccount = this.dipData.declinedAccount();
        let declinedCard = this.dipData.declinedCard();
        let declinedOD = this.dipData.declinedOD();
        let bureauDecline = this.dipData.bureauDecline;

        return `<h3 class="displayMessageDiph3">
        <span class="red-bg-text">Based on the information provided</span>
        <br /> You are eligible for the
        <strong>${refferedAccount.productType ? refferedAccount.productDescription : ''}</strong>
        <span>${refferedOD && refferedOD.productType ? ' with <strong>Overdraft</strong>': ''}</span>
        <span>${refferedCard.productType && (refferedOD.productType || refferedAccount.productType) ? ' and ': ''}</span>
        <strong>${refferedCard.productType ? refferedCard.productDescription : ''}</strong>
        </h3>
        <h6>
            <span>
                <span class="displayMessageDipSpan">${!bureauDecline ? 'However, we will need further information from you before we can provide you with a final approval.<br /> Unfortunately, based on this information we are not able to offer you the': ''}
                    <span>${!bureauDecline && declinedOD && declinedOD.productType ? '<span class="displayMessageDipSpan">Overdraft</span>':''}</span>
                    <span>${!bureauDecline && declinedCard.productType && (declinedOD.productType || declinedAccount.productType) ? ' and ': ''}</span>
                    <span class="displayMessageDipSpan"> ${!bureauDecline ? declinedCard.productDescription : ''}</span>
                </span>
        </h6>
        <h6>
            <span style="color: #a0adb4;">${bureauDecline ? '<br />However, based on information you have <a href="" onClick="${showBureauInfo()}"><u>provided</u></a> we will need further information from you before we can provide you with final approval.</span>' : ''}
        </h6>`;
    }

    constructor(data) {
        this.dipData = data;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/dip.model.ts